const colorForDesignHomePage: {
  backcolor: string;
  frontcolor: string;
  marker_out_color: string;
  marker_in_color: string;
  is_mobile?: boolean;
  mobile_sort?: number;
}[] = [
  {
    backcolor: "#000000",
    frontcolor: "#000000",
    marker_out_color: "#000000",
    marker_in_color: "#000000",
    is_mobile: true,
    mobile_sort: 0,
  },
  {
    backcolor: "#6B6B6B",
    frontcolor: "#6B6B6B",
    marker_out_color: "#4aa2d3",
    marker_in_color: "#ffffff",
    is_mobile: true,
    mobile_sort: 1,
  },
  {
    backcolor: "#AF2418",
    frontcolor: "#AF2418",
    marker_out_color: "#4aa2d3",
    marker_in_color: "#ffffff",
    is_mobile: true,
    mobile_sort: 4,
  },
  {
    backcolor: "#EA3423",
    frontcolor: "#EA3423",
    marker_out_color: "#4aa2d3",
    marker_in_color: "#ffffff",
  },
  {
    backcolor: "#ED7531",
    frontcolor: "#ED7531",
    marker_out_color: "#4aa2d3",
    marker_in_color: "#ffffff",
  },
  {
    backcolor: "#744E40",
    frontcolor: "#744E40",
    marker_out_color: "#4aa2d3",
    marker_in_color: "#ffffff",
  },
  {
    backcolor: "#9E3571",
    frontcolor: "#9E3571",
    marker_out_color: "#4aa2d3",
    marker_in_color: "#ffffff",
  },
  {
    backcolor: "#D44797",
    frontcolor: "#D44797",
    marker_out_color: "#4aa2d3",
    marker_in_color: "#ffffff",
  },
  {
    backcolor: "#6733B9",
    frontcolor: "#6733B9",
    marker_out_color: "#4aa2d3",
    marker_in_color: "#ffffff",
  },
  {
    backcolor: "#183BD2",
    frontcolor: "#183BD2",
    marker_out_color: "#4aa2d3",
    marker_in_color: "#ffffff",
    is_mobile: true,
    mobile_sort: 2,
  },
  {
    backcolor: "#0F0B9A",
    frontcolor: "#0F0B9A",
    marker_out_color: "#0F0B9A",
    marker_in_color: "#ffffff",
    is_mobile: true,
    mobile_sort: 3,
  },
  {
    backcolor: "#3578F6",
    frontcolor: "#3578F6",
    marker_out_color: "#3578F6",
    marker_in_color: "#ffffff",
  },
  {
    backcolor: "#51AAAC",
    frontcolor: "#51AAAC",
    marker_out_color: "#4aa2d3",
    marker_in_color: "#ffffff",
    is_mobile: true,
    mobile_sort: 6,
  },
  {
    backcolor: "#4A9B6A",
    frontcolor: "#4A9B6A",
    marker_out_color: "#4aa2d3",
    marker_in_color: "#ffffff",
    is_mobile: true,
    mobile_sort: 5,
  },
];

export default colorForDesignHomePage;
